import { fetchPodcastId } from "../../components/helpers/utils";

const hitApi = async (played, duration, activeEpisode, isLivePodcast, podcast) => {
  const episodeId = activeEpisode.link.split("/").filter(Boolean).pop();
  const podcastId = fetchPodcastId(activeEpisode.itunes.image, podcast.details.link);
  const baseUrl = isLivePodcast ? 'https://apis.hubhopper.com/v5' : 'https://apis.hubhopper.co/stage';
  const apiKey = isLivePodcast ? '9s0pBnORiaaMMCPvl1vcL3HrOJLFQ38j4bqk8Aw3' : 'DdjDiUOzsC7nn0t95VTJi9CC29kb9o5A1yr6zTdk';
  const endpoint = `/analytics/podcasts/${podcastId}/episodes/${episodeId}/embedplayer/track`;
  const url = `${baseUrl}${endpoint}`;
  // multiplying with total duration because played is in percentage.
  var playbackPosition = parseFloat((played * duration).toFixed(2))
  var totalDuration = parseFloat(duration.toFixed(2))
  if (playbackPosition < 3) {
    return
  }
  // only sending analytics > 3 secs of playback
  const requestBody = {
    playbackPosition: playbackPosition,
    totalDuration: totalDuration,
  };
  // console.log(requestBody)
  // if (isLivePodcast) return;
  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
        "x-api-key": apiKey,
      },
    });

    if (!response.ok) {
      throw new Error("Something went wrong");
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    throw new Error("Something went wrong");
  }
};

export default hitApi;
